import { z } from 'zod';
import { IsoTimestamp, Role, SchoolId, UserId } from './common.js';
export const User = z.object({
    id: UserId,
    schoolId: SchoolId,
    role: Role,
    displayName: z.string().min(1).max(200),
    email: z.string().email().optional(),
    studentNumber: z.string().max(64).optional(),
    aimsisStringId: z.string().max(64).nullable().optional(),
    /** @deprecated Use ClassMemberships collection instead. Retained for backward compatibility. */
    classroomIds: z.array(z.string().max(64)).default([]),
    /** @deprecated Use TeachingAssignments collection instead. Retained for backward compatibility. */
    subjectIds: z.array(z.string().max(100)).default([]),
    aimsisId: z.string().max(64).optional(), // origin id when synced from legacy AIMSIS
    createdAt: IsoTimestamp,
    updatedAt: IsoTimestamp,
});
export const UserAuditLog = z.object({
    id: z.string(),
    actorId: z.string(),
    // field/oldValue/newValue are only written by field-level changes like
    // email_change; lifecycle actions (password_reset, totp_reset,
    // auth_pool_adoption) record just the action.
    action: z.enum(['email_change', 'password_reset', 'totp_reset', 'auth_pool_adoption']),
    field: z.string().optional(),
    oldValue: z.string().nullable().optional(),
    newValue: z.string().nullable().optional(),
    createdAt: IsoTimestamp,
});
export const Classroom = z.object({
    id: z.string().min(1).max(64),
    schoolId: SchoolId,
    name: z.string().min(1).max(200),
    gradeLevel: z.string().max(32).optional(),
    studentIds: z.array(UserId).default([]),
    aimsisId: z.string().max(64).optional(),
    createdAt: IsoTimestamp,
    updatedAt: IsoTimestamp,
});
//# sourceMappingURL=user.js.map